import {
    EndpointDefinition,
    EndpointModifiers,
    EndpointParameterDefinition,
    TypeExpressionParser,
    TypeMapper,
} from '@elrondnetwork/erdjs/out'

const typeParser = new TypeExpressionParser()
const typeMapper = new TypeMapper()

export const getWhitelistDataEndpointDef = () => {
    let types = ['tuple4<bool, u8, u32, BigUint, u32>']
        .map((expression) => typeParser.parse(expression))
        .map((type) => typeMapper.mapType(type))
    let endpointDefinitions = types.map(
        (type) => new EndpointParameterDefinition('foo', 'bar', type)
    )

    let endpointDef = new EndpointDefinition(
        'getWhitelistInfo',
        [],
        endpointDefinitions,
        new EndpointModifiers('', [])
    )
    return endpointDef
}
